import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography, Empty, Spin } from 'antd';
import { TeamOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

function CallersList() {

  const [callers, setCallers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {

    const authToken = localStorage.getItem('authToken');
    
    axios.get(`${process.env.REACT_APP_API_URL}/callers`, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
    .then(res => {

        const zoomName = localStorage.getItem('zoomName');

        let visibleCallers = res.data;

        setCallers(visibleCallers);
        setLoading(false);
        
      })
      .catch(err => {

        console.error("Error fetching callers:", err);

        setLoading(false);

      });

  }, []);

  if (loading) return <Spin tip="Cargando llamadores..." size="large" style={{ display: 'flex', justifyContent: 'center', marginTop: '20%', color: '#f49b33' }} />;

  return (
    <div style={{ padding: '24px', backgroundColor: '#2a2b2b', minHeight: '70vh' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <Title level={2} style={{ 
          color: '#f49b33', 
          textAlign: 'center', 
          marginBottom: '24px'
        }}>
          <TeamOutlined style={{ marginRight: '10px' }} /> Lista de Llamadores
        </Title>

        <Row gutter={[24, 24]}>
          {callers.map(({ name, imageUrl }) => (
            <Col key={name} xs={24} sm={12} md={8} lg={6} xl={4}>
              <div style={{
                height: '100%',
                borderRadius: '8px',
                overflow: 'hidden',
                transition: 'all 0.3s ease'
              }}>
                <Card
                  hoverable
                  onClick={() => navigate(`/caller/${encodeURIComponent(name)}`)}
                  style={{ 
                    backgroundColor: '#353435',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    height: '100%',
                    border: 'none',
                    paddingBottom: '16px',
                    overflow: 'hidden'
                  }}
                  bodyStyle={{ 
                    padding: '0',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                  }}
                >
                  <div style={{
                    width: '100%',
                    height: '160px',
                    overflow: 'hidden',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#2a2b2b'
                  }}>
                    <img 
                      src={imageUrl} 
                      alt={name}
                      style={{ 
                        height: '100%',
                        width: 'auto',
                        maxWidth: '100%',
                        objectFit: 'contain',
                        transition: 'transform 0.3s ease'
                      }} 
                    />
                  </div>
                  
                  <div style={{
                    padding: '16px 16px 0',
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Text 
                      strong 
                      style={{ 
                        color: '#fff', 
                        fontSize: '16px',
                        textAlign: 'center',
                        transition: 'color 0.3s ease'
                      }}
                    >
                      {name}
                    </Text>
                  </div>

                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '2px',
                    background: '#f49b33',
                    transform: 'scaleX(0)',
                    transformOrigin: 'left',
                    transition: 'transform 0.3s ease'
                  }} />
                </Card>
              </div>
            </Col>
          ))}
        </Row>

        {callers.length === 0 && (
          <Empty 
            description={<span style={{ color: '#aaa' }}>No hay llamadores registrados</span>} 
            style={{ marginTop: '48px' }} 
            imageStyle={{ filter: 'invert(60%)', opacity: 0.7 }}
          />
        )}
      </div>
        
      <style>{`
        .ant-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease !important;
        }
        .ant-card:hover {
          transform: translateY(-4px) !important;
          box-shadow: 0 6px 16px rgba(244, 155, 51, 0.15) !important;
        }
        .ant-card:hover img {
          transform: scale(1.03);
        }
        .ant-card:hover .ant-typography {
          color: #f49b33 !important;
        }
        .ant-card:hover > div:last-child {
          transform: scaleX(1);
        }
      `}</style>
    </div>
  );
}

export default CallersList;